
import favicon from 'assets/images/fav.ico';

export default {
    favicon
};
